export default function ButtonCard({
  title,
  text,
  boldText,
  btnText,
  selected,
  onButtonClick,
}) {
  return (
    <div
      className={`border-2 text-center hover:cursor-pointer ${
        selected
          ? "border-primary shadow-primary"
          : "border-altDark shadow-transparent"
      } rounded-2xl p-8 bg-gradient-to-br from-altDark/20 via-transparent shadow-glow`}
      onClick={onButtonClick}
    >
      <span className="pointer-events-none">
        <h4 className="mb-0">{title}</h4>

        {text && (
          <p className="font-indi my-4">
            {text}
            {boldText ? (
              <strong>
                <br />
                {boldText}
              </strong>
            ) : (
              ""
            )}
          </p>
        )}
        {btnText && (
          <>
            <hr />
            <span
              className={`btn btn-outlined btn-secondary ${
                selected ? "btn-primary !border-primary !shadow-primary" : ""
              } block mt-8 !mb-0 !mr-0 !w-full`}
            >
              {btnText}
            </span>
          </>
        )}
      </span>
    </div>
  );
}
